export default __webpack_public_path__ + "bfd1755b13daf53d8865d2240c86f822.png";